<template>
  <bm-dialog
    :label="title"
    :width="mergedOptions.width"
    :dialog-type="mergedOptions.type"
    :closeable="mergedOptions.closeable"
    :large="mergedOptions.large"
    @accept="emit('accept')"
    @cancel="emit('cancel')"
  >
    <v-row>
      <v-col cols="12">
        <span
          v-if="mergedOptions.isBodyHtml"
          class="pre-wrap"
          v-html="message"
        />
        <span v-else class="pre-wrap">{{ message }}</span>
      </v-col>
    </v-row>

    <template #controls="props">
      <bm-dialog-controls
        v-bind="props"
        :cancelable="true"
        :large="mergedOptions.large"
        data-qa="confirmation-dialog-controls"
      >
        <template #controls-confirm-text>
          {{ mergedOptions.customConfirmButtonText || $m.ok }}
        </template>
        <template #controls-cancel-text>
          {{ mergedOptions.customCancelButtonText || $m.cancel }}
        </template>
      </bm-dialog-controls>
    </template>
  </bm-dialog>
</template>

<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import BmDialogControls from "@/components/dialogs/BmDialogControls.vue";
import { computed } from "vue";
import type { BmConfirmationDialogOptions } from "@/components/dialogs/DialogTypes";
import { EnumDialogType } from "@/components/dialogs/DialogTypes";

const defaultOptions: BmConfirmationDialogOptions = {
  type: EnumDialogType.none,
  width: 350,
  customConfirmButtonText: "",
  customCancelButtonText: "",
  closeable: true,
  isBodyHtml: false,
  large: false,
};

interface BmConfirmationDialogProps {
  title?: string;
  message?: string;
  options?: Partial<BmConfirmationDialogOptions>;
}

const props = withDefaults(defineProps<BmConfirmationDialogProps>(), {
  title: "",
  message: "",
  options: () => ({}),
});

const emit = defineEmits<{
  (event: "accept"): void;
  (event: "cancel"): void;
}>();

const mergedOptions = computed(() => ({
  ...defaultOptions,
  ...props.options,
}));
</script>
<style lang="sass" scoped>
.pre-wrap
  white-space: pre-wrap
</style>
